import { Component, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { SlatAssessmentStatus } from '../../../../models/slat/slat-assessment-status'

@Component({
  selector: 'app-slat-assessment-status-modal',
  templateUrl: './slat-assessment-status-modal.component.html',
  styleUrl: './slat-assessment-status-modal.component.scss',
  standalone: false,
})
export class SlatAssessmentStatusModalComponent {
  SlatAssessmentStatus = SlatAssessmentStatus
  selectedStatus: SlatAssessmentStatus = SlatAssessmentStatus.Completed

  constructor(
    public dialogRef: MatDialogRef<SlatAssessmentStatusModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data?: { selectedStatus?: SlatAssessmentStatus },
  ) {
    this.selectedStatus = data?.selectedStatus ?? SlatAssessmentStatus.Completed
  }

  onStatusChange(value: string) {
    this.selectedStatus = Number(value) as SlatAssessmentStatus
  }

  close(action: 'cancel' | 'continue') {
    if (action === 'continue') {
      this.dialogRef.close(this.selectedStatus)
      return
    }
    this.dialogRef.close(null)
  }
}
